/**
 * Shopify Payment Terms Accessibility Fixer
 * Resolves ARIA issues inside the dynamically injected shopify-payment-terms web component.
 */
(function() {
  'use strict';

  function fixPaymentTerms() {
    const paymentTermsElements = document.querySelectorAll('shopify-payment-terms:not([data-a11y-fixed])');
    
    paymentTermsElements.forEach(element => {
      // 1. Give the wrapper element a region role so screen readers can navigate to it
      if (!element.hasAttribute('role')) {
        element.setAttribute('role', 'region');
      }
      if (!element.hasAttribute('aria-label')) {
        element.setAttribute('aria-label', 'Payment Installment Options');
      }

      // 2. If the web component uses an Open Shadow DOM, we need to fix elements inside it
      if (element.shadowRoot) {
        fixShadowDOM(element.shadowRoot);
      } else {
        fixShadowDOM(element); // Fallback for light DOM
      }
      
      element.setAttribute('data-a11y-fixed', 'true');
    });
  }

  function fixShadowDOM(root) {
    // Issue A: The "Learn more" or info modal button lacks a proper aria-label or expanded state
    const buttons = root.querySelectorAll('button');
    buttons.forEach(btn => {
      // Fix buttons with empty text (like SVG info icons)
      if (!btn.hasAttribute('aria-label') && btn.textContent.trim() === '') {
        btn.setAttribute('aria-label', 'Learn more about Shop Pay installments');
      }
      // Fix buttons that open modals but lack aria-expanded state
      if (btn.hasAttribute('aria-haspopup') && !btn.hasAttribute('aria-expanded')) {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', () => {
          const isExpanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', (!isExpanded).toString());
        });
      }
    });

    // Issue B: Iframes inside the component missing descriptive titles
    const iframes = root.querySelectorAll('iframe');
    iframes.forEach(iframe => {
      if (!iframe.hasAttribute('title') || iframe.getAttribute('title').trim() === '') {
        iframe.setAttribute('title', 'Shop Pay Installments Information');
      }
    });

    // Issue C: Links without discernible text
    const links = root.querySelectorAll('a:not([aria-label])');
    links.forEach(link => {
      if (link.textContent.trim() === '') {
        link.setAttribute('aria-label', 'Learn more about payment terms');
      }
    });
  }

  function initFixer() {
    fixPaymentTerms();

    // Observe the DOM for the component being added late by Shopify scripts
    const observer = new MutationObserver(mutations => {
      let shouldProcess = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE && (node.matches('shopify-payment-terms') || node.querySelector('shopify-payment-terms'))) {
              shouldProcess = true;
              break;
            }
          }
        }
      }
      
      if (shouldProcess) {
        // Debounce to give the web component time to construct its shadow DOM
        setTimeout(fixPaymentTerms, 300);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Web components lazily populate their shadow root even after being mounted.
    // We run a recurring check to ensure the shadow DOM gets patched once it hydrates.
    let checks = 0;
    const interval = setInterval(() => {
      const elements = document.querySelectorAll('shopify-payment-terms');
      elements.forEach(el => {
        if (el.shadowRoot) fixShadowDOM(el.shadowRoot);
      });
      checks++;
      if (checks > 15) clearInterval(interval); // Stop checking after 15 loops
    }, 1000);
  }

  // Auto-initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFixer);
  } else {
    initFixer();
  }
})();
